import axios from "axios";
import { BasicPaymentInformation, SubscribeResponse } from "common";

const appConfig = require("../app_config.json");

class PaymentService {
    async subscribe(planName: string, token: string): Promise<SubscribeResponse> {
        const response = await axios.post(
            `${appConfig.baseUrl}${appConfig.stage}/create-payment-session`,
            { planName },
            { headers: { "Authorization": token } }
        );

        return Promise.resolve(response.data);
    }

    async updateSubscriptionStatus(subscriptionID: string, desiredStatus: BasicPaymentInformation["status"], token: string): Promise<void> {
        await axios.post(
            `${appConfig.baseUrl}${appConfig.stage}/update-subscription`,
            { subscriptionID, desiredStatus },
            { headers: { "Authorization": token } }
        );

        return Promise.resolve();
    }
}

export default new PaymentService();